module.exports = __webpack_public_path__ + "img/logo-brand-vnpt.4fa81635.png";